import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  TextField,
  DialogActions,
  DialogContent,
} from "@material-ui/core";
import { CommonConfig } from "CommonConfig";
import GridContainer from "components/Grid/GridContainer";
import { InputText } from "primereact/inputtext";
import api from "utils/api";
import APIConstant from "utils/constant";
import GridItem from "components/Grid/GridItem";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import cogoToast from "cogo-toast";
import Datetime from "react-datetime";
import moment from "moment";
import { InputSwitch } from "primereact/inputswitch";

const initialNameState = {
  name: "",
  error: false,
  errorText: "",
};

const LoyaltyRedeemtion = (props) => {
  const [userId, setUserId] = useState("");
  const [loyaltyId, setLoyaltyId] = useState("");
  const [userPageAccess, setUserPageAccess] = useState([]);
  const [addDialog, setAddDialog] = useState(false);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [readOnly, setReadOnly] = useState(false);
  const [search, setSearch] = useState("");
  const [conversionRate, setConversionRate] = useState(initialNameState);
  const [applicableDate, setApplicableDate] = useState({
    date: new Date(),
    error: false,
    errorText: "",
  });
  const [loyaltyRedeemList, setLoyatyRedeemList] = useState([]);
  const [rowsPerPageOptions, setRowsPerPageOptions] = useState(
    CommonConfig.dataTableConfig.rowsPerPageOptions
  );
  const [rowsPerPage, setRowsPerPage] = useState(
    CommonConfig.dataTableConfig.rowsPerPage
  );

  useEffect(() => {
    let data = localStorage.getItem("Infodata");
    let token = localStorage.getItem("Token");
    let userPageAccess = localStorage.getItem("PageAccess");
    let lockstatus = localStorage.getItem("LockStatus");

    // if (lockstatus == 0) {
    if (token !== null) {
      setUserId(data);
      setUserPageAccess(userPageAccess);
      getLoyaltyRedeemList(data);
    } else {
      props.history.push("/login");
    }
    // } else {
    //     this.props.history.push('/auth/lockscreen')
    // }
  }, []);

  const getLoyaltyRedeemList = async (UserId) => {
    let params = {
      UserId,
    };
    api
      .post(APIConstant.path.GetLoyaltyRedeem, params)
      .then((response) => {
        if (response.Success === 1) {
          setLoyatyRedeemList(response.Data);
        }
      })
      .catch((err) => {});
  };

  const addUpdateLoyaltyRedeem = async () => {
    if (validate()) {
      let params = {
        LoyaltyId: loyaltyId,
        UserId: userId,
        ConversionRate: conversionRate.name,
        ApplicableDate: applicableDate.date,
      };
      api
        .post(APIConstant.path.AddUpdateLoyaltyRedeem, params)
        .then((response) => {
          if (response.Success === 1) {
            handleClose("AddDialog");
            getLoyaltyRedeemList(userId);
            cogoToast.success(response.Message);
          } else {
            cogoToast.error(response.Message);
          }
        })
        .catch((err) => {});
    }
  };

  const UpdateRedeemStatus = async (LoyaltyId, RedeemStatus) => {
    const payload = {
      LoyaltyId,
      RedeemStatus,
    };
    api
      .post(APIConstant.path.UpdateLoyaltyRedeemStatus, payload)
      .then((res) => {
        if (res.Success === 1) {
        } else {
          cogoToast.error("Error updating tier");
        }
      });
  };

  const getLoyaltyRedeemById = async (id) => {
    let params = {
      LoyaltyId: id,
      UserId: userId,
    };
    api
      .post(APIConstant.path.GetLoyaltyRedeemById, params)
      .then((response) => {
        if (response.Success === 1) {
          let data = response.Data;
          setConversionRate({
            name: data.ConversionRate,
            error: false,
            errorText: "",
          });
        }
      })
      .catch((err) => {});
  };

  const deleteLoyaltyRedeem = async () => {
    let params = {
      LoyaltyId: loyaltyId,
      UserId: userId,
    };
    api
      .post(APIConstant.path.DeleteLoyaltyRedeem, params)
      .then((response) => {
        if (response.Success === 1) {
          handleClose("DeleteMasterType");
          cogoToast.success(response.Message);
          getLoyaltyRedeemList(userId);
        }
      })
      .catch((err) => {});
  };

  const validate = () => {
    let isValid = true;
    if (CommonConfig.isEmpty(conversionRate.name)) {
      setConversionRate({
        name: "",
        error: true,
        errorText: "Please enter conversion rate",
      });
      isValid = false;
    } else {
      setConversionRate((prevState) => ({
        ...prevState,
        error: false,
        errorText: "",
      }));
    }

    if (CommonConfig.isEmpty(applicableDate.date)) {
      setApplicableDate({
        date: "",
        error: true,
        errorText: "Please enter applicable date",
      });
      isValid = false;
    } else {
      setApplicableDate((prevState) => ({
        ...prevState,
        error: false,
        errorText: "",
      }));
    }
    return isValid;
  };

  const actionTemplate = (rowData, props) => {
    return (
      <div class="bill-action icon-only-btn" style={{ display: "flex" }}>
        {userPageAccess.includes("View Loyalty Redeem") ? (
          <i
            class="icon-view"
            onClick={(e) => handleOpen(rowData, "ViewMasterType")}
          ></i>
        ) : null}
        {userPageAccess.includes("Edit Loyalty Redeem") ? (
          <i
            onClick={(e) => handleOpen(rowData, "EditMasterType")}
            class="icon-editImage"
          ></i>
        ) : null}
        {userPageAccess.includes("Delete Loyalty Redeem") ? (
          <i
            onClick={(e) => handleOpen(rowData, "DeleteMasterType")}
            class="icon-delete"
          ></i>
        ) : null}
      </div>
    );
  };

  const actionBodyTemplateSrNo = (data, props) => {
    return props.rowIndex + 1;
  };

  const handleOpen = async (e, type) => {
    if (type === "AddDialog") {
      setAddDialog(true);
    } else if (type === "ViewMasterType") {
      setLoyaltyId(e._id);
      await getLoyaltyRedeemById(e._id);
      setReadOnly(true);
      setAddDialog(true);
    } else if (type === "EditMasterType") {
      setLoyaltyId(e._id);
      await getLoyaltyRedeemById(e._id);
      setAddDialog(true);
    } else if (type === "DeleteMasterType") {
      setLoyaltyId(e._id);
      setDeleteDialog(true);
    }
  };

  const handleChange = async (e, type) => {
    if (type === "conversionRate") {
      if (CommonConfig.isEmpty(e?.target?.value)) {
        setConversionRate({
          name: "",
          error: true,
          errorText: "Please enter conversion rate",
        });
      } else {
        if (/^\d*$/i.test(e.target.value)) {
          setConversionRate({
            name: e.target.value,
            error: false,
            errorText: "",
          });
        }
      }
    } else if (type === "applicableDate") {
      if (CommonConfig.isEmpty(e)) {
        setApplicableDate({
          date: "",
          error: true,
          errorText: "Please enter applicable date",
        });
      } else {
        setApplicableDate({
          date: e,
          error: false,
          errorText: "",
        });
      }
    }
  };

  const handleClose = (type) => {
    if (type === "AddDialog") {
      setAddDialog(false);
      setConversionRate(initialNameState);
      setReadOnly(false);
      setLoyaltyId("");
    } else if (type === "DeleteMasterType") {
      setDeleteDialog(false);
      setLoyaltyId("");
    }
  };

  const actionSwitchTemplate = (rowData, props) => {
    return (
      <InputSwitch
        checked={rowData.RedeemStatus}
        onChange={(e) => {
          let tempList = [...loyaltyRedeemList];
          tempList[props.rowIndex].RedeemStatus = e.value;
          setLoyatyRedeemList(tempList);
          UpdateRedeemStatus(rowData._id, e.value);
        }}
      />
    );
  };

  return (
    <div className="wayment-owner-dashboard e-weighment-dashoard">
      <div className="heading-area p-d-flex p-ai-center p-jc-between">
        <div className="p-d-flex p-ai-center">
          <i className="pi pi-tags"></i>
          <h2>Loyalty Redeem</h2>
        </div>
        <div className="p-d-flex p-ai-center wb-filter-btn">
          <div className="searchbar-area p-as-center">
            <InputText
              type="search"
              onInput={(e) => setSearch(e.target.value)}
              placeholder="Global Search"
              size="30"
              style={{ marginRight: 10 }}
            />
            <i className="icon-search"></i>
          </div>
          {userPageAccess.includes("Add Loyalty Redeem") ? (
            <div>
              <div
                className="e-add-btn"
                onClick={(e) => handleOpen(e, "AddDialog")}
              >
                <i className="icon-add"></i>
              </div>
            </div>
          ) : null}
        </div>
      </div>
      <hr />

      <div className="main-access-card-master ">
        <DataTable
          className="main-table table-td"
          // style={{ height: "calc(100vh - 196px)" }}
          value={loyaltyRedeemList}
          editMode="row"
          dataKey="_id"
          responsiveLayout="scroll"
          paginator={true}
          rows={rowsPerPage}
          totalRecords={loyaltyRedeemList.length}
          rowsPerPageOptions={rowsPerPageOptions}
          globalFilter={search}
          emptyMessage="No records found"
          responsive={false}
          resizableColumns={true}
          columnResizeMode="fit"
          scrollable={true}
          scrollWidth="auto"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        >
          <Column
            field="Index"
            header="Sr.No"
            body={actionBodyTemplateSrNo}
            style={{ width: "20%" }}
          ></Column>
          <Column
            field="ConversionRate"
            header="Conversion Rate"
            style={{ width: "20%" }}
          ></Column>
          <Column
            field="ApplicableDate"
            header="Applicable Date"
            style={{ width: "20%" }}
            body={(data) =>
              data.ApplicableDate
                ? moment(data.ApplicableDate).format("DD/MM/YYYY")
                : "-"
            }
          ></Column>
          <Column
            field="EndDate"
            header="End Date"
            style={{ width: "20%" }}
            body={(data) =>
              data.EndDate ? moment(data.EndDate).format("DD/MM/YYYY") : "-"
            }
          ></Column>
          <Column
            field="RedeemStatus"
            header="Status"
            style={{ width: "20%" }}
            body={actionSwitchTemplate}
          ></Column>
          <Column
            field="Action"
            header="Action"
            body={actionTemplate}
            headerStyle={{ width: "10%", minWidth: "8rem" }}
            bodyStyle={{ textAlign: "center" }}
          ></Column>
        </DataTable>
      </div>

      <Dialog
        // className="stock-modal"
        open={addDialog}
        onClose={() => handleClose("AddDialog")}
        aria-labelledby="cha-form-dialog-title"
        // style={{ height: '500px'}}
      >
        <DialogTitle
          id="cha-form-dialog-title"
          className="custom-dialog-header"
        >
          <div>Add Conversion Rate</div>
          <div
            className="dialog-close"
            onClick={(e) => handleClose("AddDialog")}
          >
            <i className="icon-modal-close"></i>
          </div>
        </DialogTitle>
        <GridContainer>
          <GridItem md={12}>
            <TextField
              autoFocus
              margin="dense"
              name="Conversion Rate"
              label="Conversion Rate"
              type="text"
              value={conversionRate.name}
              onChange={(e) => handleChange(e, "conversionRate")}
              error={conversionRate.error}
              helperText={conversionRate.errorText}
              fullWidth
              inputProps={{ maxLength: 15 }}
              disabled={readOnly}
            />
          </GridItem>

         {/* =======================         Due to dynamic value addition, the height of 
         the bottom column is increasing automatically.   ===================== */}
          <GridItem md={12}>
            <Datetime
              className="p-mt-1"
              value={moment(applicableDate.date)}
              onChange={(e) => handleChange(e, "applicableDate")}
              disabled={readOnly}
              closeOnSelect={true}
              timeFormat={false}
              dateFormat="DD/MM/YY"
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Applicable Date"
                  disabled={readOnly}
                  fullWidth
                  className="input-box"
                  error={applicableDate.error}
                  helperText={applicableDate.errorText}
                />
              )}
            />
          </GridItem>
        </GridContainer>
        <DialogActions className="p-p-0 dialog-footer1">
          <Button
            className="primary-btn1"
            onClick={(e) => handleClose("AddDialog")}
          >
            Cancel
          </Button>
          {!readOnly && (
            <Button
              className="primary-btn"
              onClick={(e) => addUpdateLoyaltyRedeem(e)}
              type="submit"
            >
              Submit
            </Button>
          )}
        </DialogActions>
      </Dialog>

      <Dialog
        open={deleteDialog}
        onClose={() => handleClose("DeleteMasterType")}
        aria-labelledby="cha-form-dialog-title"
      >
        <DialogTitle
          id="cha-form-dialog-title"
          className="custom-dialog-header"
        >
          <div>Delete Conversion</div>
          <div
            className="dialog-close"
            onClick={(e) => handleClose("DeleteMasterType")}
          >
            <i className="icon-modal-close"></i>
          </div>
        </DialogTitle>
        <DialogContent className="CHA-dialog-content-area">
          <h6>Are you sure want to delete?</h6>
        </DialogContent>
        <DialogActions className="p-p-0 dialog-footer1">
          <Button
            className="primary-btn1"
            onClick={(e) => handleClose("DeleteMasterType")}
          >
            Close
          </Button>
          <Button
            className="primary-btn"
            onClick={(e) => deleteLoyaltyRedeem(e)}
            type="submit"
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default LoyaltyRedeemtion;
